import { VehicleEngineType, VehicleType } from '@travelity/api/generated';
import { VehicleGroup } from './create-asser-modal.types';

export const mapVehiclesByType: Record<VehicleGroup, VehicleType[]> = {
    [VehicleGroup.AUTOMOBILE]: [
        VehicleType.CAR,
        VehicleType.TRUCK,
        VehicleType.BUS,
        VehicleType.VAN,
        VehicleType.SUV,
        VehicleType.RV,
        VehicleType.MOTORCYCLE,
        VehicleType.BICYCLE,
        VehicleType.SCOOTER,
        VehicleType.HOVERBOARD,
    ],
    [VehicleGroup.BOAT]: [
        VehicleType.SAILBOAT,
        VehicleType.MOTORBOAT,
        VehicleType.CATAMARAN,
        VehicleType.RIB,
        VehicleType.GULET,
        VehicleType.JETSKI,
        VehicleType.HOUSEBOAT,
        VehicleType.SAILING_YACHT,
        VehicleType.MOTOR_YACHT,
    ],
    [VehicleGroup.AIRCRAFT]: [VehicleType.AIRPLANE, VehicleType.HELICOPTER],
};

export const fuelOptions = [
    { value: VehicleEngineType.ELECTRIC, label: 'Electric' },
    { value: VehicleEngineType.DIESEL, label: 'Diesel' },
    { value: VehicleEngineType.PETROL, label: 'Petrol' },
    { value: VehicleEngineType.CNG, label: 'CNG' },
    { value: VehicleEngineType.LPG, label: 'LPG' },
];
